<template>
  <v-card class="ma-4">
    <v-tabs v-model="tab">
      <v-tab>
        <v-icon left>fas fa-calendar</v-icon>
        <span v-if="!isXSmall">Calendar View</span>
      </v-tab>
      <v-tab>
        <v-icon left>fas fa-list</v-icon>
        <span v-if="!isXSmall">List View</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-if="termRec" v-model="tab">
      <v-tab-item>
        <calendar-view :term="term" :term-start="termRec ? termRec.start : ''" :schedule="schedule"></calendar-view>
      </v-tab-item>
      <v-tab-item>
        <list-view :term="term" :schedule="schedule" :updated-at="lastUpdated"></list-view>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<style>
.v-slide-group__prev--disabled, .v-slide-group__next--disabled {
  display: none !important;
}
.toolbar-title-button {
  cursor: pointer;
  border: 1px solid rgba(0,0,0,.01)
}
.toolbar-title-button:hover {
  border: 1px solid #DEDEDE;
  background-color: #DEDEDE;
}
</style>
<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import { stringFormatDate } from '@/helpers/formatters'

export default {
  components: {
    ListView: () => import('@/components/student/schedule/list'),
    CalendarView: () => import('@/components/student/schedule/calendar')
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user)
    const isLoaded = ref(false)
    const terms = ref([])
    const term = ref('')
    const termRec = computed(() => terms.value.find(({ term: dTerm }) => dTerm === term.value))
    const termLabel = computed(() => termRec.value != null ? termRec.value.label : '**Select Term**')
    const termStarted = computed(() => termRec.value != null && new Date(termRec.value.start) < new Date())
    const termEnded = computed(() => termRec.value != null && new Date(termRec.value.end) < new Date())
    const schedule = computed(() => termRec.value != null ? termRec.value.schedule : [])
    const classes = computed(() => termRec.value != null ? termRec.value.classes : [])
    const lastUpdated = computed(() => termRec.value != null ? stringFormatDate(termRec.value.updatedAt) : '')

    const bannerId = computed(() => root.$route.params.bannerId)
    const pidm = ref(null)
    const placement = computed(() => root.$route.params.placement)
    const workstudyList = ref([])

    onMounted(async () => {
      root.$store.commit('setHeaderVisible', false)
      root.$store.commit('setSideNavActive', false)
      let doLogout = false
      if (bannerId.value !== '' && bannerId.value != null) {
        if (!user.value.username) {
          console.log('doing auth')
          await auth()
          doLogout = true
        } else {
          console.log(user.value.username)
        }
        const { data } = await root.$feathers.service('directory/people').find({ query: { bannerId: bannerId.value } })
        if (data.length > 0) {
          pidm.value = data[0].pidm
          await load()
        }
      }
      if (doLogout) {
        console.log('doing logout')
        root.$feathers.logout().then(() => {
          root.$store.dispatch('logout')
        })
      } else {
        console.log('not doing logout')
      }
      console.log(window.parent.location.href)
    })

    async function auth () {
      // await root.$feathers.service('users').create({
      //   username: 'slateUser',
      //   password: 'slateU53r7CN6ls.x0*hm3nsl!',
      //   email: 'jmoon@covenant.edu',
      //   name: 'User, Slate',
      //   preferred: 'SlateUser',
      //   roles: ['Parent']
      // })
      try {
        const response = await root.$feathers.authenticate({
          strategy: 'local',
          username: 'slateUser',
          password: 'slateU53r7CN6ls.x0*hm3nsl!'
        })
        if ('user' in response) {
          // root.$feathers.set('user', response.user)
          // root.$store.dispatch('login', response.user)
        }
      } catch (e) {
        if (e.message === 'Cannot read property \'eventMappings\' of undefined') alert('Invalid username or password; logon denied')
        else alert(e.message)
      }
    }

    function loadStudentSchedule ({ value }) {
      if (value !== bannerId.value && value != null && value !== '') root.$router.push('/student/schedule/' + value)
    }

    async function load () {
      isLoaded.value = false
      const aggregate = [
        { $match: { pidm: pidm.value, 'schedule.0': { $exists: true } } },
        { $project: {
          term: 1,
          bannerId: 1,
          name: 1,
          schedule: 1,
          academics: 1,
          updatedAt: 1
        } },
        { $lookup: {
          from: 'Terms',
          localField: 'term',
          foreignField: 'term',
          as: 'termDetail'
        } },
        { $lookup: {
          from: 'Calendar-Classes',
          localField: 'term',
          foreignField: 'term',
          as: 'classes',
          pipeline: [
            { $unwind: '$students' },
            { $match: { 'students.pidm': pidm.value } },
            { $project: { crn: 1, title: 1, section: 1, credits: 1, instructor: { $first: '$instructors' }, meetingBase: 1, regStatus: '$students.regStatus' } },
            {
              $project: {
                crn: 1,
                title: 1,
                credits: 1,
                instructor: '$instructor.name',
                regStatus: 1,
                meets: {
                  $reduce: {
                    input: '$meetingBase',
                    initialValue: '',
                    in: {
                      $concat: [
                        '$$value',
                        { $cond: [{ $eq: ['$$value', ''] }, '', '<br/>'] },
                        { $cond: [{ $eq: ['$$this.days', ''] }, '', { $concat: ['$$this.days', ' '] }] },
                        { $cond: [{ $eq: ['$$this.startTime', ''] }, '', { $concat: ['$$this.startTime', ' - '] }] },
                        '$$this.endTime',
                        { $cond: [
                          { $eq: ['$$this.room', null] },
                          '',
                          { $concat: [' in ', '$$this.room', ' (', '$$this.building', ')'] }
                        ] }
                      ]
                    }
                  }
                }
              }
            },
            { $project: { crn: 1, title: 1, credits: 1, instructor: 1, regStatus: 1, meets: { $cond: [{ $eq: ['$meets', ''] }, '**No Meeting Times Specified**', '$meets'] } } }
          ]
        } },
        { $project: {
          term: 1,
          bannerId: 1,
          name: 1,
          schedule: 1,
          academics: 1,
          updatedAt: 1,
          detail: { $first: '$termDetail' },
          classes: 1
        } },
        { $project: {
          term: 1,
          bannerId: 1,
          name: 1,
          schedule: 1,
          academics: 1,
          updatedAt: 1,
          label: '$detail.label',
          start: '$detail.start',
          end: '$detail.end',
          messages: '$detail.scheduleChangeMessages',
          classes: 1
        } },
        { $sort: {
          term: -1
        } }
      ]
      let { data } = await root.$feathers.service('student/term-detail').find({ query: { aggregate } })
      terms.value = data.map((rec) => {
        const schedule = []
        // Combine the schedule and classes arrays, making sure to match on CRN
        for (const sched of rec.schedule) {
          const { crn } = sched
          const cls = rec.classes.find(({ crn: classCrn }) => classCrn === crn)
          schedule.push({ ...cls, ...sched })
        }
        return { ...rec, schedule }
      })
      if (data.length > 0) {
        const now = new Date()
        // Go through the term list and see if there is an in-progress term; if so, choose that one. If not, choose the next one (or last if they are not registered for any future terms)
        for (const { term: dTerm, start, end } of data) {
          if (new Date(end) > now) {
            if (new Date(start) < now) {
              term.value = dTerm
              break
            } else {
              term.value = dTerm
            }
          }
        }
        if (term.value === '') {
          term.value = terms.value[terms.value.length - 1].term
        }
      }
      isLoaded.value = true
    }

    const tab = ref(0)
    const isXSmall = computed(() => root.$vuetify.breakpoint.name === 'xs')
    const isSmall = computed(() => ['xs', 'sm'].includes(root.$vuetify.breakpoint.name))

    return {
      isLoaded,
      terms,
      term,
      termRec,
      termLabel,
      termStarted,
      termEnded,
      schedule,
      lastUpdated,
      bannerId,
      pidm,
      placement,
      workstudyList,
      loadStudentSchedule,
      load,
      classes,
      tab,
      isXSmall,
      isSmall,
      stringFormatDate
    }
  }
}
</script>
